<div class="grid grid-nogutter flex align-items-center justify-content-center" >
    <div class="col-3">
        <button pButton  [label]="buttonLabel"
                (click)="activateDeactivate()"
                class="light w-100 p-button-rounded" pRipple> 
        </button>
    </div>
</div>